// @flow

import React from "react";
import { zoomTableActionsConfig } from "../../../../commons/zoomTable/zoomTableConfig";
import { RenderActionButtons } from "../../../../commons/actionButton/actionButton";
import { getFormattedSLAFromMillis } from "../../../../../services/helpers";

const editImg = require("../../../../../assets/images/ic_mode_edit_black_24px.svg");
const deleteImg = require("../../../../../assets/images/ic_delete_black_24px.svg");

const getSla = row => {
  let slaToShow = "--";
  if (
    !row ||
    !row.original ||
    !row.original.slaList ||
    !row.original.slaList.length
  ) {
    return slaToShow;
  }
  row.original.slaList.forEach(sla => {
    if (sla.escalationLevel === "LEVEL_ONE") {
      slaToShow = getFormattedSLAFromMillis(sla.solvingTime);
    }
  });
  return slaToShow;
};

export const categoryDetailsTableConfig = {
  columns: [
    {
      Header: "Issue Name",
      accessor: "name"
    },
    {
      Header: "Minimum Severity",
      accessor: "minimumSeverity"
    },
    {
      Header: "Maximum Severity",
      accessor: "maximumSeverity"
    },
    {
      Header: "SLA",
      accessor: "slaList",
      Cell: row => (
        <div className="l-row l-wrap">
          <div className="flex-20">{getSla(row)}</div>
        </div>
      )
    },
    {
      Header: "Status",
      accessor: "isActive",
      Cell: row => (
        <div className="l-row l-wrap">
          {row.original.isActive ? "ACTIVE" : "INACTIVE"}
        </div>
      )
    },
    {
      Header: "Actions",
      headerClassName: "flex-15",
      className: "flex-15",
      sortable: false,
      Cell: obj => (
        <RenderActionButtons
          rowData={obj.original || {}}
          buttonConfig={zoomTableActionsConfig.CATEGORY_DETAILS_KEY.buttons}
        />
      )
    }
  ],
  className: "zoomTableLegacyWrapper",
  noDataText: "No data found",
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100]
};

export const categoryDetailsTableActionConfig = {
  buttons: [
    {
      label: "EDIT",
      iconRef: editImg,
      onClick: rowData => {
        // eslint-disable-next-line no-console
        console.log("Edit clicked row {} ", rowData);
        if (
          zoomTableActionsConfig.CATEGORY_DETAILS_KEY.actions &&
          zoomTableActionsConfig.CATEGORY_DETAILS_KEY.actions.editTicketType
        ) {
          zoomTableActionsConfig.CATEGORY_DETAILS_KEY.actions.editTicketType(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: "30%",
        height: "55%"
      }
    },
    {
      label: "DELETE",
      iconRef: deleteImg,
      onClick: rowData => {
        // eslint-disable-next-line no-console
        console.log("Delete clicked ", rowData);
        if (
          zoomTableActionsConfig.CATEGORY_DETAILS_KEY.actions &&
          zoomTableActionsConfig.CATEGORY_DETAILS_KEY.actions.deleteTicketType
        ) {
          zoomTableActionsConfig.CATEGORY_DETAILS_KEY.actions.deleteTicketType(
            rowData
          );
        }
      },
      style: {
        width: "30%",
        height: "55%"
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/categorySettings/categoryDetails/categoryDetailsHelper.js